import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';

export const DeloitteMenuButton = withStyles({
  root: {
    borderRadius:0,
    padding:'12px 32px',
    textTransform: 'none'
  },
  label:{
      fontWeight:500,
      fontSize:'1 rem'
  }
})(Button);
